import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Carpeta",
  "use": "Carpeta-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Carpeta\"><path d=\"M60 20H29a2 2 0 0 1-2-2v-7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v46a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V21a1 1 0 0 0-1-1zm-30-3h31a3 3 0 0 1 3 3v38a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol